import { HttpClient, HttpParams } from '@angular/common/http';
import { SecurityRoleType, TokenUser } from '@jms/model';
import * as Enumerable from 'linq';
import { BehaviorSubject, Subject } from 'rxjs';
import { catchError, debounceTime, filter, map } from 'rxjs/operators';
import { ISearcher } from '../interfaces/search.interface';
import { UserSearcherParams } from './core.data.searcher';




export class UserSearcher implements ISearcher {
  protected _searchSubject = new Subject<UserSearcherParams>();
  public readonly data$ = new BehaviorSubject<TokenUser[]>([]);

  constructor(
    private http: HttpClient,
    private endPoint: string,
    private allowReturnAll = true,
    private includeInvites = false,
    private security: SecurityRoleType[] = [],
    existing: any
  ) {

    this._searchSubject
      .pipe(
        debounceTime(300),
        filter(query => {
          if (this.allowReturnAll) return true;
          return query ? true : false;
        })
      )
      .subscribe(query => {
        this.getData(query);
      });

  }

  public searchWithSecurity(security: SecurityRoleType, query?: string) {
    this._searchSubject.next({ security: [security], query: query });
  }

  public searchTechnicians(query?: string) {
    this._searchSubject.next({ security: [SecurityRoleType.EmployeeTechnician, SecurityRoleType.EmployeeAdministrator, SecurityRoleType.SubcontractorAdministrator, SecurityRoleType.SubcontractorUser], query: query });
  }

  public search(query?: string) {
    this._searchSubject.next({ security: this.security, query: query });
  }

  public getResult() {
    return this.data$;
  }

  public getData(search: UserSearcherParams, existing: () => TokenUser[] = () => []) {

    const query = {};
    if (search.security)
      query['security'] = search.security.join(';');

    if (search.query)
      query['filter'] = search.query;

    if (this.includeInvites)
      query['invites'] = true;

    const params = new HttpParams({ fromObject: query });
    const options = { params: params };

    this.http
      .get<TokenUser[]>(this.endPoint, options)
      .pipe(
        map(x => {

          const data = Enumerable
            .from(x)
            .select(user => {

              const expired = user.complianceExpiry
                ? new Date() > new Date(user.complianceExpiry)
                : false;

              user['disabled'] = expired;

              return user;
            })
            .except(existing(), c => c.name)
            .orderBy(c => c.name)
            .toArray();

          this.data$.next(data);

        }),
        catchError(error => {
          console.log(error);
          return null;
        }))
      .subscribe();
  }
}
